/**
 * @file case-study-filters.js
 */
(function($, Drupal, drupalSettings) {
  'use strict';

  function initFilters(selectedProduct = "", selectedService = "") {
    let $productFilter = $('#ddlProducts');
    let $serviceFilter = $('#ddlServices');

    if (selectedProduct !== '') {
      $productFilter.val(selectedProduct);
    }
    if (selectedService !== '') {
      $serviceFilter.val(selectedService);
    }

    if ($productFilter.length && $serviceFilter.length) {
      $productFilter.on('change', (e) => {
        $('input[name="field_related_products_target_id"]').val($productFilter.val());
        triggerUpdate();
      });
      $serviceFilter.on('change', (e) => {
        $('input[name="field_related_services_target_id"]').val($serviceFilter.val());
        triggerUpdate();
      });
    }
  }

  function triggerUpdate() {
    $('form.views-exposed-form').find('input[type="submit"]').trigger('click');
  }

  Drupal.behaviors.caseStudyFilters = {
    attach: function (context, settings) {
      initFilters();

      $(context).ajaxComplete(function (event, xhr, settings) {
        let productFilter = $('input[name="field_related_products_target_id"]').val();
        let serviceFilter = $('input[name="field_related_services_target_id"]').val();

        initFilters(productFilter, serviceFilter);
      });
    }
  };

})(jQuery, Drupal, drupalSettings);
